import {createTheme} from '@mui/material';

import {lightPalette} from './lightPalette';
import {
  sharedTypography,
  sharedBreakpoints,
  sharedTypographyOverrides,
} from './sharedThemeConfig';

/**
 * Erster Durchlauf: Basis-Theme mit Palette, Typografie und Breakpoints erstellen,
 * damit Palette-Tokens in den Komponenten-Overrides referenziert werden können.
 */
const baseTheme = createTheme({
  palette: lightPalette,
  typography: sharedTypography,
  breakpoints: sharedBreakpoints,
});

export const lightTheme = createTheme(baseTheme, {
  components: {
    MuiPaper: {defaultProps: {variant: 'outlined'}},
    MuiMenu: {defaultProps: {slotProps: {paper: {variant: 'elevation'}}}},
    MuiButton: {
      styleOverrides: {
        contained: {
          '&:hover': {
            boxShadow: 8,
            color: baseTheme.palette.common.white,
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {'&:focus': {backgroundColor: 'transparent'}},
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: baseTheme.palette.secondary.main,
          },
          '&.MuiTableRow-hover:hover': {
            backgroundColor: baseTheme.palette.secondary.light,
          },
          '&.Mui-selected.MuiTableRow-hover:hover': {
            backgroundColor: baseTheme.palette.secondary.dark,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          '&.selected': {
            backgroundColor: baseTheme.palette.secondary.main,
          },
        },
      },
    },
    MuiTreeItem: {
      styleOverrides: {
        content: {
          '&:hover': {
            backgroundColor: baseTheme.palette.secondary.light,
          },
          '&[data-selected]:hover, &[data-selected][data-focused]:hover': {
            backgroundColor: baseTheme.palette.secondary.dark,
          },

          '&[data-selected], &[data-selected][data-focused]': {
            backgroundColor: baseTheme.palette.secondary.main,
          },
          '&[data-focused]': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiTypography: sharedTypographyOverrides,
    MuiCssBaseline: {
      styleOverrides: {
        '*, *::before, *::after': {
          fontFamily: 'Lato, sans-serif !important',
        },
        body: {
          backgroundImage: 'none',
        },
      },
    },
  },
});
